import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=40c96868"
import script from "./editForm.vue?vue&type=script&lang=js"
export * from "./editForm.vue?vue&type=script&lang=js"
import style0 from "./editForm.vue?vue&type=style&index=0&id=40c96868&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports